var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalaxydust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1589,
    height: 928,
    viewBox: "0 0 1589 928",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "galaxy_dust1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M1627.42 763.804C1627.42 726.899 1756.12 547.705 1586.98 471.715C1417.84 395.726 1057.53 519.655 978.483 514.926C899.431 510.197 796.56 442.344 717.435 486.691C638.311 531.037 695.338 574.062 688.061 614.468C680.784 654.874 607.165 635.54 614.515 681.231C621.792 726.18 694.925 739.881 697.205 740.275C673.313 728.985 642.192 647.803 796.511 582.848C950.831 517.893 1241.37 568.684 1351.67 630.278C1461.96 691.872 1513.43 821.782 1439.91 876.235C1376.17 923.456 1279.26 927.699 1254.59 928H1685V818.258C1685 818.258 1627.42 800.686 1627.42 763.804ZM875.757 520.397C859.99 521.811 844.224 522.553 828.311 523.642C816.717 524.431 804.928 525.265 794.086 529.276C764.978 540.148 746.543 572.556 715.495 576.659C713.081 577.067 710.605 577.004 708.218 576.473C699.679 574.155 697.278 563.793 696.987 555.309C696.599 544.39 697.157 533.124 701.838 523.156C709.115 507.809 725.246 497.656 742.274 493.414C759.302 489.171 777.251 490.191 794.74 492.023C823.848 494.781 854.532 499.325 882.355 508.087C899.698 513.558 887.715 519.307 875.757 520.397ZM1374.98 534.12C1345.87 542.953 1316.06 550.348 1285.62 552.99C1244.14 556.491 1202.49 550.788 1161.28 545.132C1140.98 542.327 1117.62 540.495 1098.96 531.802C1072.5 519.516 1105.17 509.826 1118.88 505.375C1162.54 491.165 1202.22 479.528 1247.44 470.394C1275.07 464.807 1314.39 455.975 1342.57 457.389C1359.07 458.224 1370.1 467.218 1384.27 475.355C1399.16 483.909 1411.31 501.921 1403.31 516.665C1397.93 526.447 1385.97 530.782 1374.98 534.12ZM1412.36 541.075C1405.91 539.777 1401.88 531.339 1406.08 526.447H1407.29C1410.32 524.02 1413.88 522.284 1417.72 521.371C1419.65 520.971 1421.66 521.196 1423.44 522.01C1425.22 522.824 1426.66 524.182 1427.54 525.868C1428.15 527.7 1428.15 529.669 1427.54 531.501C1425.46 537.598 1418.83 542.373 1412.36 541.075ZM1455.34 678.797C1451 699.661 1436.86 684.987 1431.54 674.161C1427.57 666.163 1420.17 653.599 1421.84 644.326C1423.69 633.593 1433.82 634.729 1441.83 640.547C1453.28 649.009 1458.08 665.653 1455.34 678.797ZM1560.13 834.555C1558.36 841.834 1556.1 849.368 1550.74 854.862C1542.49 863.323 1528.18 864.691 1517.12 859.985C1506.06 855.279 1498.06 845.473 1493.28 834.856C1488.5 824.239 1486.53 812.648 1484.62 801.22C1479.06 767.954 1473.82 734.642 1467.95 701.423C1464.58 682.39 1457.89 645.601 1492.21 652.347C1506.15 655.207 1519.21 661.12 1530.35 669.619C1541.5 678.119 1550.43 688.973 1556.44 701.33C1563.09 715.239 1565.71 730.678 1567.02 745.954C1569.52 775.651 1567.2 805.539 1560.13 834.555ZM1592.83 502.107C1590.96 507.554 1584.24 509.71 1578.39 510.985C1545.59 518.155 1512 521.525 1478.36 521.023C1463.81 520.791 1448.67 519.632 1436.57 512.052C1423.78 504.054 1411.65 485.114 1411.39 470.162C1411.02 451.246 1439.91 458.687 1454.61 459.615C1496.51 462.253 1537.79 470.654 1577.18 484.558C1585.55 487.549 1595.69 493.993 1592.83 502.107Z",
    fill: "url(#paint0_linear_324_1516)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M991 402L990 403C990.22 402.54 990.575 402.185 991 402Z",
    fill: "url(#paint1_linear_324_1516)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M841.455 334.085C850.329 326.992 859.129 319.481 864.882 309.931C867.085 306.799 868.17 303.077 867.978 299.314C866.93 290.251 854.912 286.635 845.331 287.029C823.391 287.956 803.353 298.457 785.143 310.047C773.173 317.673 761.203 326.273 754.865 338.628C752.495 343.087 751.182 347.987 751.018 352.981C750.853 357.975 751.842 362.942 753.915 367.534C759.887 379.657 767.786 376.412 779.072 372.17C802.158 363.547 822.538 349.129 841.455 334.085Z",
    fill: "#2C319D"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M1481.15 928C1481.15 928 1557.47 904.302 1577.71 835.625C1597.95 766.947 1584.99 683.656 1559.32 650.921C1533.64 618.185 1405.75 629.616 1389.2 597.926C1372.65 566.236 1454.73 556.896 1455.96 540.424C1457.2 523.951 1515.18 541.26 1574.87 530.41C1634.57 519.56 1663.3 573.392 1662.24 620.811C1661.17 668.23 1654.28 729.681 1659.81 764.02C1665.34 798.359 1685 842.664 1685 869.917V928H1481.15Z",
    fill: "url(#paint2_linear_324_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.15,
    d: "M708 602.366C708 602.366 748.442 544.131 793.688 533.388C838.933 522.644 883.257 545.729 910.138 529.59C937.018 513.451 956.718 490.065 1038.86 495.321C1121.01 500.577 1157.74 489 1157.74 489C1157.74 489 1074.38 511.715 1064.58 523.987C1054.78 536.259 1124.96 567.981 1247.07 533.388C1420.21 484.23 1441.68 661.827 1464.85 740.553C1488.02 819.279 1454.42 862 1454.42 862C1454.42 862 1476.55 779.06 1421.38 714.226C1366.21 649.393 1267.35 694.915 1166.01 644.021C1064.68 593.127 888.23 539.778 708 602.366Z",
    fill: "url(#paint3_linear_324_1516)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1408.86 429.887C1457.25 428.623 1509.09 436.907 1551.14 413.88C1555.26 411.962 1558.75 408.982 1561.23 405.269C1564.45 399.582 1563 392.211 1559.15 386.899C1554.99 381.778 1549.65 377.661 1543.57 374.871C1487.97 345.736 1418.54 355.635 1360.47 380.183C1342.25 387.858 1303.64 407.96 1310.9 432.367C1315.74 448.608 1340.32 437.329 1353.6 435.293C1371.88 432.329 1390.34 430.523 1408.86 429.887Z",
    fill: "#4184BB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.02 378.318C1590.17 379.643 1594.88 382.155 1598.71 385.619C1602.2 389.339 1603.39 395.4 1599.9 399.142C1595.14 404.239 1586.06 401.69 1580.06 397.925C1576.3 395.906 1573.22 392.966 1571.16 389.43C1570.16 387.651 1569.79 385.624 1570.11 383.641C1570.43 381.657 1571.42 379.818 1572.94 378.387C1576.24 375.793 1582.44 376.964 1583.43 380.844L1585.02 378.318Z",
    fill: "#4184BB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1399.38 849.736C1403.34 854.258 1408.3 857.886 1413.89 860.358C1416.68 861.574 1419.74 862.128 1422.8 861.975C1425.87 861.822 1428.85 860.965 1431.49 859.476C1436.33 856.345 1438.91 850.756 1440.75 845.399C1449.58 819.312 1449.04 791.139 1439.21 765.385C1433.28 750.008 1421.97 733.078 1403.98 729.576C1388.82 726.607 1368.22 735.351 1364.04 750.449C1360.34 763.9 1367.45 784.82 1371.12 797.645C1376.49 816.826 1385.43 835.055 1399.38 849.736Z",
    fill: "#4184BB"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0C0 0 103.069 6.42632 188.969 42.7571C274.868 79.0878 251.553 146.158 263.818 178.847C276.082 211.535 328.855 178.707 359.529 185.806C390.202 192.906 326.937 248.84 354.671 250C382.406 251.16 485.402 214.783 532.59 250C574.58 281.343 492.105 311.247 407.445 348.761C322.784 386.275 332.547 435.389 353.384 440.794C374.222 446.2 280.988 450.399 283.441 473.413C285.894 496.427 288.079 500 288.079 500C288.079 500 281.619 490.047 292.038 475.385C302.457 460.723 460.777 463.669 490.818 438.474C520.86 413.28 482.367 381.612 485.354 372.819C488.341 364.027 765.686 323.613 814.768 250.046C863.85 176.48 822.054 143.653 823.365 103.888C824.677 64.124 897 0 897 0H0Z",
    fill: "url(#paint4_linear_324_1516)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324_1516",
    x1: 613.957,
    y1: 687.467,
    x2: 1685,
    y2: 687.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#070019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D6DAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_324_1516",
    x1: 990.508,
    y1: 403,
    x2: 990.508,
    y2: 402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#070019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_324_1516",
    x1: 1387.02,
    y1: 728.496,
    x2: 1685,
    y2: 728.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#070019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D6DAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_324_1516",
    x1: 708,
    y1: 675.488,
    x2: 1473.08,
    y2: 675.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#070019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D6DAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_324_1516",
    x1: 448.488,
    y1: 499.907,
    x2: 448.488,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6DAE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxydust);
export default __webpack_public_path__ + "static/media/galaxydust.db3be86ba463aab9c332a116905f37ba.svg";
export { ForwardRef as ReactComponent };